$(document).ready(function () {
  $(".user_create").click(function (e) {
    let account = $("#user_account").val();
    let password = $("#user_password").val();
    let password_check = $("#user_password_check").val();
    {
      if (account == "") {
        e.preventDefault();
        content =
          '<input type=text name="user[account]" id="user_account" placeholder="此欄位必填">';
        $("#user_account").parent().html(content);
      }

      if (password == "") {
        e.preventDefault();
        content =
          '<input type=password name="user[password]" id="user_password" placeholder="此欄位必填">';
        $("#user_password").parent().html(content);
      } else if (password.length < 8) {
        e.preventDefault();
        content =
          '<input type=password name="user[password_digest]" id="user_password" placeholder="密碼強度不足">';
        $("#user_password").parent().html(content);
      } else if (
        password.match(/[a-z]/) == null &&
        password.match(/[A-Z]/) == null
      ) {
        e.preventDefault();
        content =
          '<input type=password name="user[password_digest]" id="user_password" placeholder="密碼強度不足">';
        $("#user_password").parent().html(content);
      } else if (password.match(/\d/) == null) {
        e.preventDefault();
        content =
          '<input type=password name="user[password_digest]" id="user_password" placeholder="密碼強度不足">';
        $("#user_password").parent().html(content);
      } else if (password.match(/[^a-zA-Z\d]/) == null) {
        e.preventDefault();
        content =
          '<input type=password name="user[password_digest]" id="user_password" placeholder="密碼強度不足">';
        $("#user_password").parent().html(content);
      }

      if (password_check == "") {
        e.preventDefault();
        content =
          '<input type=password name="password_check" id="user_password_check" placeholder="此欄位必填">';
        $("#user_password_check").parent().html(content);
      } else if (password_check != password) {
        e.preventDefault();
        content =
          '<input type=password name="password_check" id="user_password_check" placeholder="密碼確認不相符">';
        $("#user_password_check").parent().html(content);
      }
    }
  });
});
